import { HttpParams } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { GbApiService } from 'libs/shared/data-access-core/src/lib/+state/gb-api.service'
import { Observable } from 'rxjs'
import { TablesPaginatedResponse, TablesEntity } from './tables.models'

@Injectable({
  providedIn: 'root',
})
export class TablesApiService extends GbApiService {
  getTables(
    urlName: string,
    offset: number,
    searchTerm?: string,
    ordering?: string,
  ): Observable<TablesPaginatedResponse> {
    let params = new HttpParams().set('limit', this.appConfig.itemsPageSize).set('offset', offset)
    if (searchTerm) params = params.set('search', searchTerm)
    if (ordering) params = params.set('ordering', ordering)

    const url = `auctions/${urlName}/tables/`
    return this.get<TablesPaginatedResponse>(url, { params })
  }

  createTable(urlName: string, table: Partial<TablesEntity>): Observable<TablesEntity> {
    const url = `auctions/${urlName}/tables/`
    return this.post<TablesEntity>(url, table)
  }

  // not currently used but could be useful in the future
  bulkCreateTables(urlName: string, tables: Partial<TablesEntity[]>): Observable<TablesEntity[]> {
    const url = `auctions/${urlName}/tables/bulk-create/`
    return this.post<TablesEntity[]>(url, { tables })
  }

  updateTable(urlName: string, table: Partial<TablesEntity>): Observable<TablesEntity> {
    const url = `auctions/${urlName}/tables/${table.uuid}/`
    return this.patch<TablesEntity>(url, table)
  }

  deleteTable(urlName: string, table: TablesEntity) {
    const url = `auctions/${urlName}/tables/${table.uuid}/`
    return this.delete<void>(url)
  }

  assign(urlName: string, tableUuid: string, tickets?: string[], profiles?: string[]) {
    const url = `auctions/${urlName}/tables/${tableUuid}/assign/`
    return this.post<void>(url, { tickets, profiles })
  }

  remove(urlName: string, tableUuid: string, tickets?: string[], profiles?: string[]) {
    const url = `auctions/${urlName}/tables/${tableUuid}/remove/`
    return this.post<void>(url, { tickets, profiles })
  }
}
